export default "__VITE_ASSET__2248723e__"